"use client";

import Popup from "../PopupComponent/Popup";
import { ReactNode } from "react";

interface HomeClientWrapperProps {
  children: ReactNode;
  showPopup?: boolean;
}

const HomeClientWrapper: React.FC<HomeClientWrapperProps> = ({
  children,
  showPopup = true,
}) => {
  // Temporary: Clear localStorage for testing
  if (typeof window !== "undefined") {
    localStorage.removeItem("popup-shown");
    console.log("Cleared popup-shown from localStorage for testing");
  }

  return (
    <>
      {children}

      {showPopup && (
        <Popup
          title="Ny Patient?"
          content="Book nemt en forundersøgelse som ny patient ved at ringe på 43 96 02 55 eller sende en e-mail på info@ctandklinik.dk. Du kan også bruge vores kontaktformular som du finder her "
          buttonText="Book Tid Nu"
          buttonLink="/bliv-ny-patient-hos-ctandklinik-din-tandlaege-i-glostrup"
          image="/img/pngegg.png"
          imageAlt="Professionel tandbehandling hos CTandKliniken"
          delay={5000} // Show after 5 seconds for testing
          showOnce={true} // Only show once per session
          autoClose={15000} // Auto close after 15 seconds
        />
      )}
    </>
  );
};

export default HomeClientWrapper;
